const STORAGE_KEY = 'slot-battle-openings-seen';
const MAX_ENTRIES = 20;

/**
 * Battle segments whose opening pane the player has dismissed.
 *
 * core sends `opening.required` for the whole live window and records nothing, so show-once is the
 * client remembering, per device. Keyed by user as well: a browser can be shared.
 */
export const openingSeenKey = (userId: number | string, runKey: string, segmentKey: string) =>
  `${userId}:${runKey}:${segmentKey}`;

export const readSeenOpenings = (): string[] => {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as unknown;
    return Array.isArray(data) ? data.filter((value): value is string => typeof value === 'string') : [];
  } catch {
    return [];
  }
};

/** Records the key and returns the updated list, newest first. */
export const markOpeningSeen = (key: string): string[] => {
  const seen = readSeenOpenings();

  if (seen.includes(key)) {
    return seen;
  }

  const next = [key, ...seen].slice(0, MAX_ENTRIES);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Private mode or quota: the pane stays dismissed for this session only.
  }

  return next;
};
